import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c15aad96"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "border bg-mainBg py-3"
}
const _hoisted_2 = { class: "grid grid-cols-8" }
const _hoisted_3 = { class: "number" }
const _hoisted_4 = { class: "title border-dashed" }
const _hoisted_5 = {
  key: 0,
  class: "grid grid-cols-8 cursor-pointer"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "number" }, "+", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NewTitleModal = _resolveComponent("NewTitleModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_Transition, { name: "fade" }, {
      default: _withCtx(() => [
        (_ctx.isOwner || _ctx.titles?.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.titles, (title, index) => {
                return (_openBlock(), _createElementBlock("div", { key: title }, [
                  _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, _toDisplayString(index + 1), 1),
                    _createElementVNode("div", _hoisted_4, _toDisplayString(title), 1)
                  ])
                ]))
              }), 128)),
              (_ctx.isOwner)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    _hoisted_6,
                    _createElementVNode("div", {
                      class: "title opacity-60 text-mainGreen",
                      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openNewTitleModal && _ctx.openNewTitleModal(...args)))
                    }, " Add a new title ")
                  ]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_component_NewTitleModal, { ref: "modal" }, null, 512)
  ], 64))
}